import { useEffect, useState } from "react";

export function useProductForSaleStatusNeo({
  vendorProducts,
}: {
  vendorProducts: Array<VendorOptionFromServer>;
}): UseProductForSaleStatusReturnValue {
  const [isAvailableToPurchase, setIsAvailableToPurchase] = useState(false);
  const [isOutOfStock, setIsOutOfStock] = useState<boolean>(false);
  const [inStockVendorCount, setInStockVendorCount] = useState(0);
  useEffect(() => {
    if (vendorProducts.length === 0) {
      setIsAvailableToPurchase(false);
      setIsOutOfStock(false);
    } else {
      let inStockVendors = 0;
      let allVendorProductsOutOfStock = true;
      vendorProducts.forEach((vendorProduct) => {
        if (vendorProduct.inStock === true) {
          inStockVendors = ++inStockVendors;
          allVendorProductsOutOfStock = false;
        }
      });
      setInStockVendorCount(inStockVendors);
      if (allVendorProductsOutOfStock === true) {
        setIsAvailableToPurchase(false);
        setIsOutOfStock(true);
      } else {
        setIsAvailableToPurchase(true);
        setIsOutOfStock(false);
      }
    }
  }, [vendorProducts.length]);

  return {
    availabeToPurchase: isAvailableToPurchase,
    outOfStock: isOutOfStock,
    inStockVendorCount: inStockVendorCount,
  };
}

interface UseProductForSaleStatusReturnValue {
  availabeToPurchase: boolean;
  outOfStock: boolean;
  inStockVendorCount: number;
}
